import(/* webpackMode: "eager", webpackExports: ["Client","Skeleton"] */ "/home/r11/choice-graphics/src/app/(pub)/gallery/[slug]/client.tsx");
